<template>
    <div class="breakdown">
      <div class="search">
        <div class="search_box">
          <div  class="search_options_box">
            <span style="width: 100px;">{{search[0].title}}</span>
            <el-select class="select" v-model="selectProjectValue" placeholder="请选择项目" @change="getSelectTeam(selectProjectValue )">
              <el-option v-for="item in search[0].options" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </div>
          <div  class="search_options_box">
            <span style="width: 100px;">{{search[1].title}}</span>
            <el-select class="select" v-model="selectTeamValue" placeholder="请选择群组" @change="getSelectWork(selectTeamValue )">
              <el-option v-for="item in search[1].options" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </div>
          <div  class="search_options_box">
            <span style="width: 100px;">{{search[2].title}}</span>
            <el-select class="select" v-model="selectWorkValue" placeholder="请选择小组" >
              <el-option v-for="item in search[2].options" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </div>
          <div class="search_btn_box">
            <button :class='["search_btn","green","icon_btn","clearborder"]' @click="breakdownList()"><span class="el-icon-search"></span>搜索</button>
          </div>
          <div class="add_btn_box">
            <button :class='["add_btn","delete","icon_btn","clearborder"]'><span class="el-icon-delete"></span>批量删除</button>
            <button :class='["add_btn","add","icon_btn","clearborder"]'><span class="el-icon-download"></span>下载</button>
          </div>
        </div>
      </div>
      <!--        表格-->
      <div class="table_content">
        <table>
          <thead>
          <tr>
            <th style="padding-left: 30px"><input type="checkbox" name="checkbox" style="width: 16px;height: 16px"></th>
            <th>工单编号</th>
            <th>设备编号</th>
            <th>项目名称</th>
            <th>灯杆编号</th>
            <th>故障时间</th>
            <th>位置信息</th>
            <th>目前状态</th>
            <th>维保完成时间</th>
            <th>维保人</th>
            <th>联系电话</th>
            <th>备注</th>
            <th>操作</th>
          </tr>
          </thead>
          <tbody>
          <tr  v-for="(item,index) in tabledata">
            <td style="padding-left: 30px"><input type="checkbox" name="checkbox"></td>
            <td>{{item.work_number}}</td>
            <td>{{item.device_id}}</td>
            <td>{{item.project_name}}</td>
            <td>{{item.lamppost_id}}</td>
            <td>{{item.create_datetime}}</td>
            <td>{{item.address}}</td>
            <td v-if="item.status='0'">关闭</td>
            <td v-else>开启</td>
            <td>{{item.finish_datetime}}</td>
            <td>{{item.user}}</td>
            <td>{{item.mobile}}</td>
            <td>--</td>
            <td class="table_btn_box">
              <button class="table_btn" @click="projecteditor=!projecteditor" style=" margin-right: 10px;">编辑</button>
              <button class="table_btn" @click="deleteProject(item.id)">删除</button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="table_paging">
        <p>当前记录<span>{{(this.currentPage-1)*9+1}}</span>到<span>{{(this.currentPage-1)*9+this.tabledata.length}}</span>条，共<span>{{totalCount}}</span>条记录
          <button
            v-bind:style="[{background:'url(/static/img/icon/table_start.png) no-repeat center center'}]"></button>
          <button
            @click="prevPage()" v-bind:style="[{background:'url(/static/img/icon/table_prep.png) no-repeat center center'}]"></button>
          第<span>{{currentPage}}</span>/<span>{{totalPage}}</span>页
          <button
            @click="nextPage()" v-bind:style="[{background:'url(/static/img/icon/table_next.png) no-repeat center center'}]"></button>
          <button
            v-bind:style="[{background:'url(/static/img/icon/table_end.png) no-repeat center center'}]"></button>
        </p>
      </div>


      <!--  编辑-->
      <transition name="fade">
        <div class="mark" v-if="projecteditor">
          <div class="mark_close" @click="projecteditor=!projecteditor"></div>
          <div :class='["information_box","light_border","weather_box"]'
               :style="[{width:'800px'},{'margin-top':'0px'}]">
            <div class="border_top_left"></div>
            <div class="border_top_right"></div>
            <div class="border_bottom_left"></div>
            <div class="border_bottom_right"></div>
            <div class="h_light_right" :style="{top:'95px'}"></div>
            <div class="information_content issue_search_box model">
              <h1>
                编辑
              </h1>
              <div style="color:white;padding-left: 140px;padding-top: 40px;">
                保修完成时间：<el-input v-model="PFinishTime" placeholder="请输入完成时间" style="width: 240px;" ></el-input>
              </div>
              <div style="color:white;padding-left: 188px;padding-top: 40px;">
                保修人：<el-input v-model="PPerson" placeholder="请输入保修人" style="width: 240px;"></el-input>
              </div>
              <div style="color:white;padding-left: 170px;padding-top: 40px;">
                联系电话：<el-input v-model="PPhone" placeholder="请输入联系电话" style="width: 240px;"></el-input>
              </div>
              <div style="color:white;padding-left: 202px;padding-top: 40px;">
                备注：<el-input v-model="Ptext" placeholder="请输入备注" style="width: 240px;"></el-input>
              </div>
              <div class="sbt_box" style="padding-top: 30px;">
                <button :class='["add_btn","delete","icon_btn","clearborder"]'  @click="projecteditor=!projecteditor">关闭</button>
                <button :class='["add_btn","add","icon_btn","clearborder"]' @click="projecteditor=!projecteditor">提交</button>
              </div>
            </div>
          </div>
        </div>
      </transition>



    </div>
</template>

<script>
    export default {
        name: "breakdown",
      data() {
        return {
          PFinishTime:'',
          PPerson:'',
          PPhone:'',
          Ptext:'',
          projecteditor:false,
          //分页
          totalCount: 0, // 统共页数，默认为1
          totalPage: 1, // 统共页数，默认为1
          currentPage: 1, //当前页数 ，默认为1
          pageSize: 9, // 每页显示数量
          currentPageData: [], //当前页显示内容
          search: [
            {
              title: '选择项目',
              options: [],
            }, {
              title: '选择群组',
              options: [],
            }, {
              title: '选择小组',
              options: [],
            },
          ],
          projectList:[],
          teamList:[],
          workList:[],
          selectProjectValue:'17e3b71e-b460-498e-b0ef-657d20bd6549',
          selectTeamValue:'',
          selectWorkValue:'',
          tabledata: []
        }
      },
      created: function () {
          this.getProjectList();
        $(function () {
          let aa = $(".aa"),
            bb = $(".bb");
          aa.css('display', 'block');
          aa.find('ul').hide();
          aa.click(function () {
            $(this).find('ul').slideDown(500);
            $(this).siblings().children("ul").slideUp(500);
          });
          bb.click(function () {
            bb.removeClass('now');
            $(this).addClass('now');
          })
        }),
          //获取故障列表
          fetch("/api/v1/fault/list", {
            method: 'post',
            body: JSON.stringify({
              "project_id":this.selectProjectValue,
              // "fault_type":"1",
              // "device_type":"lamp",
              "page_start":this.currentPage-1,
              "page_size":this.pageSize,
              })
            })
            .then(result => {
              return result.json();//解析流
            })
            .then(data => {
              this.tabledata = data.data;
              this.totalCount = data.total_count;
              this.totalPage = Math.ceil(this.totalCount / this.pageSize);
              this.selectProjectValue='';
            })
            .catch((error) => {
              console.log(error);
            });
      },
      methods: {
        addClassFun: function (index) {
          this.qwerqwre = index;
        },

        //上一页
        prevPage() {
          console.log(this.currentPage);
          if (this.currentPage == 1) {
            return false;
          } else {
            this.currentPage--;
            this.breakdownList();
          }
        },
        // 下一页
        nextPage() {
          if (this.currentPage == this.totalPage) {
            return false;
          } else {
            this.currentPage++;
            this.breakdownList();
          }
        },


        deleteProject:function(id){
          fetch("/api/v1/fault/delete", {
            method: 'post',
            body: JSON.stringify({
              "fault_id":[id],
            })
          })
            .then(result => {
              return result.json();//解析流
            })
            //.then(data => console.log(data))
            .then(data => {
              if (data.code == "200") {
                this.message = "删除成功!";
                alert(this.message);
                this.breakdownList();
              } else {
                this.message = "数据更新异常，请重试";
              }
            })
            .catch((error) => {
              this.message = "网络异常，请重试";
              this.msg_show = !this.msg_show;
            });
        },


        breakdownList:function(){
          //获取故障列表
          fetch("/api/v1/fault/list", {
            method: 'post',
            body: JSON.stringify({
              "project_id":this.selectProjectValue,
              // "fault_type":"1",
              // "device_type":"lamp",
              "page_start":this.currentPage-1,
              "page_size":this.pageSize,
            })
          })
            .then(result => {
              return result.json();//解析流
            })
            .then(data => {
              this.tabledata = data.data;
              this.totalCount = data.total_count;
              this.totalPage = Math.ceil(this.totalCount / this.pageSize);
              this.selectProjectValue='';
              this.selectWorkValue='';
              this.selectTeamValue='';
            })
            .catch((error) => {
              console.log(error);
            });
        },


        //获取小组列表
        getSelectWork:function(id){
          fetch("/api/v1/controller/list", {
            method: 'post',
            body: JSON.stringify({
              "groups_id":id,
              "page_size":10,
              "page_start":0,
            })
          })
            .then(result => {
              return result.json();//解析流
            })
            //.then(data => console.log(data))
            .then(data => {
              if (data.code == "200") {
                this.message = "小组数据获取成功";
                this.search[2].options=[];
                this.workList = data.data;
                let options = this.search[2].options;
                for (let i=0;i<this.workList.length;i++){
                  let projectObj = {};
                  projectObj.label = this.workList[i].name;
                  projectObj.value = this.workList[i].id;
                  options.push(projectObj);
                };
              } else {
                this.message = "数据更新异常，请重试";
              }
            })
            .catch((error) => {
              this.message = "网络异常，请重试";
              this.msg_show = !this.msg_show;
            });
        },



        //获取群组列表
        getSelectTeam:function(id){
          fetch("/api/v1/groups/list", {
            method: 'post',
            body: JSON.stringify({
              "project_id":id,
              "page_size":10,
              "page_start":0,
            })
          })
            .then(result => {
              return result.json();//解析流
            })
            //.then(data => console.log(data))
            .then(data => {
              if (data.code == "200") {
                this.selectTeamValue='',
                this.selectWorkValue='',
                this.message = "群组数据获取成功";
                this.search[1].options=[];
                this.search[2].options=[];
                this.teamList = data.data;
                let options = this.search[1].options;
                for (let i=0;i<this.teamList.length;i++){
                  let projectObj = {};
                  projectObj.label = this.teamList[i].name;
                  projectObj.value = this.teamList[i].id;
                  options.push(projectObj);
                };
              } else {
                this.message = "数据更新异常，请重试";
              }
            })
            .catch((error) => {
              this.message = "网络异常，请重试";
              this.msg_show = !this.msg_show;
            });
        },


        //获取项目列表
        getProjectList:function(){
          fetch("/api/v1/project/list", {
            method: 'post',
            body: JSON.stringify({

            })
          })
            .then(result => {
              return result.json();//解析流
            })
            //.then(data => console.log(data))
            .then(data => {
              if (data.code == "200") {
                this.message = "项目数据获取成功";
                this.projectList = data.data;
                let options = this.search[0].options;
                for (let i=0;i<this.projectList.length;i++){
                  let projectObj = {};
                  projectObj.label = this.projectList[i].name;
                  projectObj.value = this.projectList[i].id;
                  options.push(projectObj);
                };
              } else {
                this.message = "数据更新异常，请重试";
              }
            })
            .catch((error) => {
              this.message = "网络异常，请重试";
              this.msg_show = !this.msg_show;
            });
        },
      }
    }
</script>

<style scoped>
  .breakdown{
    width: 100%;
    height: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }
  .search {
    width: 100%;
    height: 100px;
    padding: 20px 0px 0px;
  }

  .search_box {
    width: 100%;
    height: 100%;
    margin-right: 10px;
    background: #16518d;
    border-radius: 6px;
    float: left;
    display: flex;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
    position: relative;
  }

  .search_options_box {
    width: 16%;
    padding: 0 10px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .search_options_box > span {
    width: 64px;
    margin-right: 8px;
    text-align: right;
    color: #FFFFFF;
  }

  .search_options_box > select {
    width: calc(100% - 72px);
    height: 36px;
    border-radius: 6px;
    background: transparent;
    border: 1px solid #ffffff;
    color: #ffffff;
    appearance: none;
    padding-left: 10px;
    font-size: 16px;
    outline: none;
    cursor: pointer;
  }

  .search_options_box option {
    color: #000000;
  }

  .search_options_box > img {
    position: absolute;
    top: 48px;
    right: 20px;
    cursor: pointer;
  }

  .search_btn_box {
    width: 80px;
    padding: 10px;
  }

  .clearborder {
    outline: none;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .search_btn {
    width: 100%;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
  }

  .add_btn {
    width: 110px;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
    float: right;
    margin-right: 20px;
  }

  .icon_btn span {
    margin-right: 8px;
  }

  .green {
    background: #21b868;
    color: #FFFFFF;
  }

  .green:active {
    background: #15a95a;
  }

  .add_btn_box {
    /*width: 370px;*/
    padding: 10px;
    position: absolute;
    right: 0px;
  }

  .add {
    background: #7aafeb;
    color: #FFFFFF;
    box-shadow: 0px 3px 0px #3574ba;
  }

  .add:active {
    background: #6ca3e2;
  }

  .delete {
    background: #f2ae4d;
    color: #FFFFFF;
    box-shadow: 0px 3px 0px #dc8509;
  }

  .delete:active {
    background: #e7a342;
  }
  .table_content{
    width: 100%;
    padding: 20px 0px;
  }

  .table_content > table {
    width: 100%;
    height: 100%;
    border: 1px solid #094b8e;
    background-color: #16518d;
  }

  .table_content > table tr th{
    background-color: #0e345b;
  }
  .table_content > table tr td{
    /*background-color: #16518d;*/
  }

  .table_content > table tr td input{
    width: 16px;
    height: 16px;

  }

  .table_content > table tr:nth-child(2n){
    background-color: #11406f;
  }

  .table_content > table tr {
    /*border-bottom: 1px solid #225892;*/
    height: 62px
  }

  .table_content > table tr td, .table_content > table tr th {
    text-align: center;
    color: #FFFFFF;
  }

  .table_paging {
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    border: 1px solid #105ba8;
    border-radius: 6px;
  }

  .table_paging > p {
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: right;
    margin-bottom: 0;
    color: #c1c2c6;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
  }

  .table_paging > p > button {
    margin: 0 8px;
    width: 10px;
    height: 16px;
    border: none;
    outline: none;
  }

  .table_btn{
    color: #95bee5;
    background: transparent;
    border: 1px solid #95bee5;
    outline: transparent;
    padding: 5px 20px;
    border-radius: 6px;
  }
</style>



// WEBPACK FOOTER //
// src/components/05Management/3_breakdown.vue